import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useFetch } from '@reveni-io/reveni-ui'

import { getCustomDomain } from '@/helpers/customDomain/customDomain'
import routes from '@/Router/routes.constants'
import services from '@/services/services'

import { getTransformReturnPortalData } from './helpers'

const useReturnPortalInfo = (slug, setContext) => {
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const customDomain = getCustomDomain()
  const resolvedSlug = customDomain || slug

  if (!resolvedSlug) {
    navigate(routes.notFoundPage)
  }

  const { loading, error, data, fetchData } = useFetch(services.getReturnPortalConfig, {
    doInitialRequest: resolvedSlug,
    params: {
      slug: resolvedSlug,
    },
  })

  useEffect(() => {
    if (data) {
      setContext(context => ({ ...context, merchantInfo: getTransformReturnPortalData(data) }))
    }
  }, [data, setContext])

  useEffect(() => {
    if (customDomain && slug) {
      navigate(routes.notFoundPage)
    }
  }, [customDomain, slug, navigate])

  const changeLanguage = language => {
    i18n.changeLanguage(language)
    localStorage.language = language
    fetchData({ slug: resolvedSlug })
  }

  return {
    returnPortalInfo: data,
    errorReturnPortalInfo: error,
    loadingReturnPortalInfo: loading,
    changeLanguage,
  }
}

export default useReturnPortalInfo
